import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font } from '@react-pdf/renderer';

// Stilovi za PDF
const styles = StyleSheet.create({
    page: {
        backgroundColor: '#ffffff',
        padding: 20,
        fontFamily: 'Roboto',
    },
    table: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginTop: 10,
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableColHeader: {
        borderStyle: 'solid',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: '#001B44',
        color: '#ffffff',
        padding: 4,
        fontSize: 10,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    tableCol: {
        borderStyle: 'solid',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 4,
        fontSize: 9,
    },
    footer: {
        marginTop: 30,
        fontSize: 11,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    signatureBox: {
        width: '40%',
        borderBottomWidth: 1,
        borderBottomColor: '#000000',
        marginTop: 5,
        textAlign: 'center',
        paddingBottom: 2,
    },
});

// Širine kolona
const columnWidths = {
    id: '6%',
    lamp: '15%',
    devEUNumber: '20%',
    zona: '20%',
    prioritet: '10%',
    status: '8%',
    vrijeme: '12%',
    firma: '9%',
};

// PDF komponenta
export const AlarmsPDFDocument = ({ data }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 10 }}>
                Pregled alarma
            </Text>

            {/* Table header */}
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    <Text style={[styles.tableColHeader, { width: columnWidths.id }]}>ID</Text>
                    <Text style={[styles.tableColHeader, { width: columnWidths.lamp }]}>Lampa</Text>
                    <Text style={[styles.tableColHeader, { width: columnWidths.devEUNumber }]}>devEUNumber</Text>
                    <Text style={[styles.tableColHeader, { width: columnWidths.zona }]}>Zona</Text>
                    <Text style={[styles.tableColHeader, { width: columnWidths.prioritet }]}>Prioritet</Text>
                    <Text style={[styles.tableColHeader, { width: columnWidths.status }]}>Status</Text>
                    <Text style={[styles.tableColHeader, { width: columnWidths.vrijeme }]}>Vrijeme alarma</Text>
                    <Text style={[styles.tableColHeader, { width: columnWidths.firma }]}>Firma</Text>
                </View>

                {/* Table rows */}
                {data.map((row, index) => (
                    <View style={styles.tableRow} key={index}>
                        <Text
                            style={[
                                styles.tableCol,
                                { width: columnWidths.id, textAlign: 'right' },
                            ]}
                        >
                            {index + 1}.
                        </Text>
                        <Text style={[styles.tableCol, { width: columnWidths.lamp }]}>
                            {row.streetlamp?.installationAddress}
                        </Text>
                        <Text style={[styles.tableCol, { width: columnWidths.devEUNumber }]}>
                            {row.devEUNumber}
                        </Text>
                        <Text style={[styles.tableCol, { width: columnWidths.zona }]}>
                            {row.streetlamp?.zona?.name}
                        </Text>
                        <Text style={[styles.tableCol, { width: columnWidths.prioritet }]}>
                            {row.priority}
                        </Text>
                        <Text style={[styles.tableCol, { width: columnWidths.status }]}>
                            {row.isActive ? 'Aktivan' : 'Neaktivan'}
                        </Text>
                        <Text style={[styles.tableCol, { width: columnWidths.vrijeme }]}>
                            {row.lastTriggered
                                ? new Date(row.lastTriggered).toLocaleString('bs-BA', {
                                    hour12: false,
                                })
                                : 'N/A'}
                        </Text>
                        <Text style={[styles.tableCol, { width: columnWidths.firma }]}>
                            {row.streetlamp?.zona?.company?.name}
                        </Text>
                    </View>
                ))}
            </View>

            {/* Footer sa potpisom */}
            <View style={{ marginTop: 50, flexDirection: 'row', justifyContent: 'flex-end' }}>
                <View style={{ width: '40%', alignItems: 'center' }}>
                    {/* linija za potpis */}
                    <View style={{ borderBottomWidth: 1, borderBottomColor: '#000', width: '100%' }} />
                    {/* tekst ispod linije */}
                    <Text style={{ marginTop: 4, fontSize: 11 }}>Izvještaj kreirao</Text>
                </View>
            </View>

        </Page>
    </Document>
);
